module.exports = __webpack_public_path__ + "549d22024010d63f31d061e5a8fab59b.svg";